<form #myform="ngForm" class="form-group" style="height: 100%">
  <!--Form Header-->
  <div class="formpage-header">
    <h3 class="page-titre">
      <mat-icon>business_center</mat-icon>
      {{ titre }}
    </h3>
  </div>

  <!--Form Body-->
  <div class="formpage-body" *ngIf="currentItem">
    <div class="form-col">
      <mat-form-field appearance="outline">
        <mat-label>Code Principal</mat-label>
        <input matInput [(ngModel)]="currentItem.RateMainCode" name="RateMainCode" class="form-control" required />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Sous-Code</mat-label>
        <input matInput [(ngModel)]="currentItem.RateSubCode1" name="RateSubCode1" required />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Taux</mat-label>
        <input matInput [(ngModel)]="currentItem.RateAmount" type="number" name="RateAmount" required />
      </mat-form-field>
    </div>
  </div>

  <!--Form Footer-->
  <div class="formpage-footer">
    <button type="button" matInput mat-stroked-button (click)="detruire()" [disabled]="true" style="margin: 0px 2px 2px 2px">
      <mat-icon>delete</mat-icon>Supprimer
    </button>

    <div style="float: right">
      <button type="submit" matInput mat-flat-button (click)="OnSauvegardeClick()" *ngIf="!myform.pristine" color="primary" style="margin: 0px 2px 2px 2px">
        <mat-icon>check</mat-icon>Sauvegarder
      </button>
      <button type="submit" matInput mat-stroked-button (click)="annuler()" *ngIf="myform.pristine" style="margin: 0px 2px 2px 2px">Fermer</button>
      <button type="button" matInput mat-stroked-button (click)="annuler()" *ngIf="!myform.pristine" style="margin: 0px 2px 2px 2px">Ignorer</button>
    </div>
  </div>
</form>
